import { isGlobal } from '~/plugins/global.js'
import { assign, getMyCountry } from '~/assets/js/utils.js'

export const state = () => ({
  // 公用字段
  ip: '', // IP地址
  fullHost: '', // 完整的域名
  isMobile: false, // 当前是否为移动端
  appUserAgent: '', // App 传入的原始 User-Agent
  screenWidth: 0, // 当前屏幕的宽度
  scrollDistance: 0, // 页面滚动距离（部分页面需要使用该字段）
  langList: [
    'ar',
    'de',
    'en',
    'es',
    'fil',
    'fr',
    'hi',
    'id',
    'ja',
    'pt',
    'ru',
    'th',
    'tr',
    'vi',
    'zh',
    'zh-cn',
    'ko',
    'ur'
  ], // 国际版语言列表
  isChina: false, // 是否为国内版
  locale: 'en', // 当前选择的语言
  countryCode: '', // 当前选择的国家
  myCountry: '', // 用户所在的国家（不变的值）
  showShield: false, // 显示/隐藏红框
  // 页面头尾和菜单
  showMenu: { ea: true, vps: true }, // 是否展示菜单中的某几项（true国际版、false国内版）
  contact: '', // 底部联系方式
  countryList: [], // 底部弹框国家列表
  ipNation: {}, // 底部IP定位的国家信息
  selectNation: {}, // 底部选择的国家信息
  loginShow: false, // 是否展示登录框
  // 用户信息
  cookieVal: '', // 用户信息cookie值
  simpleUser: {}, // 用户简单信息
  phoneInfo: {}, // 手机号相关信息（国旗、手机区号、手机号等）
  riskObjData: {}, // 屏蔽点位数据
  bfp: '', // 指纹
  suffix: 'com'
})

export const getters = {
  isFxCom: state => state.fullHost?.includes(`wikifx.${state.suffix}`), // 是否为wikifx主站
  halfHost: state => '.' + state.fullHost?.split('.')?.slice(-2)?.join('.'), // 域名的一部分（例如.wikifx.com）
  cookConf: (state, getters) =>
    state.fullHost?.includes('192.168') || state.fullHost?.includes('localhost')
      ? { path: '/' } // 测试环境cookie存储位置
      : { path: '/', domain: getters.halfHost, sameSite: 'none', secure: true }, // 线上cookie存储位置
  // cookConf: state => ({ path: '/' }), // 本地cookie存储位置
  // getDiffBasic: (state, getters) => getters.isFxCom ? '999,0,2,999,0,822ca7b3261a0b2ec10c8cdabfb5a0ea,0' : '999,0,1,999,1,822ca7b3261a0b2ec10c8cdabfb5a0ea,1', // 根据不同的域名选择默认的BasicData值
  getDiffBasic: (state, getters) => state.bfp,
  // breadHome: (state, getters) => (!state.isChina ? `https://www${getters.halfHost}/${state.locale}/` : `https://www${getters.halfHost}/`) // 面包屑导航——首页
  breadHome: (state, getters) =>
    `https://www${getters.halfHost}/${state.locale}/` // 面包屑导航——首页
}

export const mutations = {
  setsuffix (state, value) {
    // 设置域名后缀
    state.suffix = value
  },
  getbfp (state, value) {
    // 指纹
    state.bfp = value
  },
  // 设置state值
  setVal (state, value) {
    assign(state, { ...value })
  },
  // 存储判断国际版/国内版的标识
  setMenu (state, value) {
    if (!Object.keys(value)?.length) return false
    assign(state.showMenu, value)
  },
  // 存储国家code
  setCountryCode (state, value) {
    state.countryCode = value
  },
  setRiskObjData (state, obj) {
    // 设置屏蔽点位
    state.riskObjData = obj
  }
}

export const actions = {
  nuxtServerInit ({ commit }, { req }) {
    if (!req.headers || !req.headers?.cookie) return false // 若没有cookie时，不执行后续操作
    const [myCook, myCountryCode] = [
      this.$cookies.get('DJkdikKMG') ||
        this.$cookies.get('ViLartidlakd') ||
        this.$cookies.get('WsdsfgDGdagYms') ||
        '',
      this.$cookies.get('CountryCode') || ''
    ]
    commit('setVal', { cookieVal: myCook })
    if (myCountryCode)
      commit(
        'setCountryCode',
        isGlobal
          ? getMyCountry({ twoCharCode: myCountryCode?.toUpperCase() })
            ?.countryCode || '840'
          : '156'
      )
  }
}
